import React from 'react';
import { Modal } from '../../components/ui';
import { fmtDateTime } from '../../utils/helpers';
import { useContactSync } from './useContactSync';

// Mobile "Phone contacts" card on the Profile page (the APK can sync; a phone
// browser cannot read the phone book and only shows status / delete).
// The disclosure is full-screen and nothing is read before "Agree".
export default function ContactSyncMobile({ user }) {
  const vm = useContactSync(user);
  const { canSync, status, consentOpen, syncing, progress, deleting, disclosure, askConsent, decline, agreeAndSync, deleteAll } = vm;
  const has = (status?.contacts || 0) > 0;

  return (
    <div className="card card-pad" style={{ marginTop: 12 }}>
      <strong>Phone contacts</strong>
      <div className="muted" style={{ fontSize: 13, margin: '4px 0 10px' }}>
        {has
          ? `${status.contacts} contacts saved${status.syncedDate ? ` · ${fmtDateTime(status.syncedDate)}` : ''}`
          : 'Sync your phone book to find people by name when adding guests.'}
      </div>
      {canSync ? (
        <button className="btn primary" style={{ width: '100%', padding: 12 }} onClick={askConsent} disabled={syncing}>
          {syncing ? `Syncing ${progress.done}/${progress.total}…` : has ? 'Sync again' : 'Sync my contacts'}
        </button>
      ) : (
        <div className="muted" style={{ fontSize: 12 }}>📱 Syncing is done from the Mehfil Android app.</div>
      )}
      {has && (
        <button className="btn danger" style={{ width: '100%', padding: 12, marginTop: 8 }} onClick={deleteAll} disabled={deleting}>
          {deleting ? 'Deleting…' : 'Delete synced contacts'}
        </button>
      )}
      {consentOpen && (
        <Modal fullScreen title="Upload your contacts?" onClose={decline}
          footer={<><button className="btn light" onClick={decline}>No thanks</button><button className="btn primary" style={{ flex: 1 }} data-save="off" onClick={agreeAndSync}>Agree &amp; sync</button></>}>
          {disclosure.map((t, i) => <p key={i} style={{ marginTop: 0, fontSize: 15 }}>{t}</p>)}
        </Modal>
      )}
    </div>
  );
}
